import './component.scss'
import $ from 'jquery'

const ROOT_TARGET_SELECTOR = '.js-toggleText-root-target'
const TOGGLE_TEXT_OPEN_TRIGGER_SELECTOR = '.js-toggleText-open-trigger'
const TOGGLE_TEXT_CLOSE_TRIGGER_SELECTOR = '.js-toggleText-close-trigger'
const TRUNCATED_TEXT_TARGET_SELECTOR = '.js-toggleText-truncated-target'
const UNTRUNCATED_TEXT_TARGET_SELECTOR = '.js-toggleText-untruncated-target'

$(() => {
  $(TOGGLE_TEXT_OPEN_TRIGGER_SELECTOR).on('click', (event) => {
    $(event.currentTarget).closest(ROOT_TARGET_SELECTOR).find(TRUNCATED_TEXT_TARGET_SELECTOR).hide();
    $(event.currentTarget).closest(ROOT_TARGET_SELECTOR).find(UNTRUNCATED_TEXT_TARGET_SELECTOR).show();
  })

  $(TOGGLE_TEXT_CLOSE_TRIGGER_SELECTOR).on('click', (event) => {
    $(event.currentTarget).closest(ROOT_TARGET_SELECTOR).find(TRUNCATED_TEXT_TARGET_SELECTOR).show();
    $(event.currentTarget).closest(ROOT_TARGET_SELECTOR).find(UNTRUNCATED_TEXT_TARGET_SELECTOR).hide();
  })
})
